angular.module("avlib").directive("avAddressEditor", function(){
	return {
		template: require("!html-loader!./AddressEditorTemplate.html"),
		restrict: "E",
		scope: {
			address: '=',
			countryVisible: '=?',
			isCoordinatesVisible: '&?showCoord',
			callbacks: '=',
		},
		controller: "addressEditorController",
		link: function(scope){
			if (!scope.isCoordinatesVisible){
				scope.isCoordinatesVisible = function(){
					return false;
				};
			}
		},
	};
});
